import { useSyncExternalStore } from "react";

interface UseCurrentTimeData {
  now: Date;
}

let store: UseCurrentTimeData = {
  now: new Date(),
};

type NotifyFn = () => void;

const notifiers = new Set<NotifyFn>();

setInterval(() => {
  store = {
    now: new Date(),
  };

  notifiers.forEach(notify => notify());
}, 1000);

function subscribe(notify: NotifyFn) {
  notifiers.add(notify);
  return () => notifiers.delete(notify);
}

function getStoreSnapshot() {
  return store;
}

export function useCurrentTime(): UseCurrentTimeData {
  return useSyncExternalStore(subscribe, getStoreSnapshot, getStoreSnapshot);
}
